import React from 'react';
import { NavButton } from './NavButton';

export const Navbar = () => {

    return (
        <nav className="navbar">
            <ul className="navbar__list">
                <NavButton subLink='dashboard' label='Dashboard'/>
                <NavButton subLink='features' label='Features'/>
                <NavButton subLink='datamanager' label='Data management'/>
                <NavButton subLink='qgate' label='Q-Gate'/>
            </ul>
        </nav>
    );
};
